import React from "react";

function Landing() {
  return (
    <div id="landing">
      <h1 className="flash">
        Everything is<span className="newLine">possible</span>
      </h1>
      <div className="social-links">
        {/*LinkedIn*/}
        <a
          href="https://www.linkedin.com/in/sebasti%C3%A1n-rodr%C3%ADguez-galarza-274552194/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fa fa-linkedin-square" aria-hidden="true" />
        </a>

        {/*Github*/}
        <a
          href="https://github.com/SebasRod23"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-github-square" aria-hidden="true" />
        </a>

        {/*Email*/}
        <a href="" target="_blank" rel="noopener noreferrer">
          <i className="fas fa-envelope" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}

export default Landing;
